import { GET_API } from "../../Functionalities/APIs";
import { partnerAdminPayoutsUrl } from "../../Constants/apiUrls";
import { csvLine } from "./csv";
import { basisParam } from "../../Functionalities/dayBasis";
import { dateInIndia, monthStartInIndia } from "./dates";

const RESTAURANT_SETTLEMENT_URL = "/accounts/settlement/restaurants/";

const bodyOf = (result) => (result && result.data ? result.data : null);

export const presets = (now = new Date()) => ({
  today: { from: dateInIndia(now), to: dateInIndia(now) },
  yesterday: { from: dateInIndia(now, -1), to: dateInIndia(now, -1) },
  last7: { from: dateInIndia(now, -6), to: dateInIndia(now) },
  thisMonth: { from: monthStartInIndia(now), to: dateInIndia(now) },
});

export const restaurantCsv = (restaurants) =>
  ["ID,Name,Orders,Owed", ...restaurants.map((r) => csvLine([Number(r.id), r.name, r.orders, Math.round(r.owed)]))].join("\n");

export const payoutPrefill = (row, { from, to, today, doneBy }) => ({
  period_from: from,
  period_to: to,
  amount: Math.round(Number(row.owed) || 0),
  difference: 0,
  pending_amount: 0,
  transaction_type: "SETTLEMENT",
  transaction_mode: undefined,
  transaction_id: "",
  done_by: doneBy || "",
  paid_on: today,
  notes: "",
});

export const payoutPayload = (branchId, values) => ({
  branch: branchId,
  amount: values.amount,
  transaction_type: values.transaction_type,
  transaction_mode: values.transaction_mode || "",
  transaction_id: (values.transaction_id || "").trim(),
  paid_on: values.paid_on,
  notes: (values.notes || "").trim(),
  period_from: values.period_from || "",
  period_to: values.period_to || "",
  difference: Number(values.difference || 0).toFixed(2),
  pending_amount: Number(values.pending_amount || 0).toFixed(2),
  done_by: (values.done_by || "").trim(),
});

export const fetchPeriodPayouts = async (from, to) => {
  const body = bodyOf(await GET_API("", `limit=200&from=${from}&to=${to}`, partnerAdminPayoutsUrl));
  if (!body) return [];
  return Array.isArray(body) ? body : body.results || [];
};

// One request: the period's totals, the day-by-day table and what each
// restaurant is owed, added up by the backend (accounts/settlement.py).
export const fetchRestaurantSettlement = async (from, to, basis) =>
  bodyOf(await GET_API("", `from=${from}&to=${to}${basisParam(basis)}`, RESTAURANT_SETTLEMENT_URL));
